import React from 'react';

import Title from '../../components/Title';
import Spreader from '../../components/Spreader';
import Paragraph from '../../components/Paragraph';
import Quote from '../../components/Quote';
import Sticker from '../../components/Sticker';
import Menu from '../../components/Menu';
import Grid from '../../components/Grid';
import Banner from '../../components/Banner';
import Scalable from '../../components/Scalable';
import Mention from '../../components/Mention';
import CallToAction from '../../components/CallToAction';

import { StickyContainer } from 'react-sticky';

const ArchitecturePage = props => (
  <StickyContainer>
    <Menu active="architecture" />
    <Spreader>
      <Title text="Глаз не отвести" />
      <Paragraph style={{ marginBottom: '10px' }}>
        Архитектура&nbsp;&mdash; единственное из&nbsp;всех направлений
        искусства, от&nbsp;которого нельзя отвернуться. Горожане ежедневно,
        хотят они этого или нет, видят город, в&nbsp;котором живут.
        От&nbsp;того, что они видят, зависит их&nbsp;настроение, самочувствие
        и&nbsp;даже мироощущение: красивый, успешный город притягивает красивых
        и&nbsp;успешных людей. Понятно, что Москва&nbsp;&mdash; город
        неоднородный, и&nbsp;в&nbsp;каждом конкретном месте
        и&nbsp;у&nbsp;каждого нового проекта уникальная миссия, зависящая
        от&nbsp;городского контекста. В&nbsp;исторической части города проекты
        не&nbsp;должны доминировать над застройкой, но&nbsp;дополнять
        ее&nbsp;и&nbsp;подчеркивать достоинства старинного города. В&nbsp;других
        районах, напротив, создавать доминанты места и&nbsp;становиться
        визуальными маркерами, открыточными видами локации и&nbsp;точками для
        селфи местного сообщества. Где-то современная застройка и&nbsp;вовсе
        является градообразующей, создает новые градостроительные оси, формирует
        улицы и&nbsp;проспекты.
      </Paragraph>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Ответственные девелоперы, берущиеся за&nbsp;такие проекты, понимают
      важность своей миссии, работают с&nbsp;известными архитекторами,
      используют в&nbsp;оформлении фасадов лучшие материалы, создавая дома
      настоящей Москвы, которые будут определять облик города десятилетия
      и&nbsp;столетия.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Бережное отношение к&nbsp;исторической части города показывают, например,
      проекты компании{' '}
      <a
        href="https://hals-development.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        &laquo;Галс-Девелопмент&raquo;
      </a>
      : такие как{' '}
      <a
        href="https://theater-house.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        &laquo;Театральный дом&raquo;
      </a>
      ,{' '}
      <a
        href="https://pekingardens.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        &laquo;Сады Пекина&raquo;
      </a>
      ,{' '}
      <a
        href="https://winehouse-hals.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        Wine House
      </a>
      .
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      &laquo;Театральный дом&raquo;&nbsp;&mdash; один из&nbsp;самых
      &laquo;неравнодушных&raquo; по&nbsp;отношению к&nbsp;окружению проектов.
      Строительство элитного квартала, расположенного на&nbsp;пересечении
      Поварской улицы и&nbsp;Мерзляковского и&nbsp;Хлебного переулков,
      завершилось в&nbsp;2017 году.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Архитектурный проект был разработан &laquo;Моспроект-2&raquo; им.&nbsp;М.
      В. Посохина и&nbsp;включает и&nbsp;реставрацию исторических фасадов,
      и&nbsp;элементы нового строительства, что делает его одним из&nbsp;самых
      интересных и&nbsp;ярких комплексов в&nbsp;центре Москвы. Застройщиком были
      проведены реставрационные работы главного фасада здания XIX века
      со&nbsp;стороны Поварской улицы, созданного архитектором Н. Д. Струковым
      в&nbsp;неоклассическом стиле, а&nbsp;также фасады со&nbsp;стороны Хлебного
      и&nbsp;Мерзляковского переулков. Внутренние фасады комплекса украшены
      декоративными панно, созданными по&nbsp;эскизам группы художников под
      руководством заслуженного архитектора России Павла Андреева в&nbsp;стиле
      ар-нуво эпохи модерна с&nbsp;растительными и&nbsp;цветочными мотивами. Для
      каждого корпуса ансамбля &laquo;Театральный Дом&raquo; разработан
      индивидуальный рисунок, выполненный из&nbsp;керамической глазурованной
      плитки.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      &laquo;Главные фасады комплекса &bdquo;Театральный Дом&ldquo; воссозданы
      в&nbsp;первоначальном виде, поэтому мы&nbsp;приняли решение украсить
      декоративным панно внутридворовое пространство, которое также является
      частью городской панорамы и&nbsp;архитектурным фоном для церкви Симеона
      Столпника. Используя различную высотность корпусов, цветовую гамму
      и&nbsp;изобразительные элементы в&nbsp;оформлении балконов
      и&nbsp;карнизов, мы&nbsp;подчеркнули индивидуальность комплекса
      &bdquo;Театральный Дом&ldquo; и&nbsp;его сомасштабность окружающей
      застройке&raquo;,&nbsp;&mdash; комментирует архитектор проекта Павел
      Андреев.
    </Spreader>
    <Spreader isDisappear>
      <Scalable style={{ marginBottom: '1.5%' }}>
        <img width="100%" src={'images/media/grid11_1_2.jpg'} />
      </Scalable>
    </Spreader>
    <Spreader isWide>
      <Sticker>
        <Quote
          author={{
            photo: 'images/media/andreev.jpg',
            position: 'архитектор проекта',
            fullName: 'Павел Андреев',
          }}
          text={
            <span>
              Главные фасады комплекса{' '}
              <a
                href="https://theater-house.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
                target="_blank"
              >
                &laquo;Театральный дом&raquo;
              </a>{' '}
              воссозданы в&nbsp;первоначальном виде, поэтому мы&nbsp;приняли
              решение украсить декоративным панно внутридворовое пространство,
              которое также является частью городской панорамы
              и&nbsp;архитектурным фоном для церкви Симеона Столпника. Используя
              различную высотность корпусов, цветовую гамму
              и&nbsp;изобразительные элементы в&nbsp;оформлении балконов
              и&nbsp;карнизов, мы&nbsp;подчеркнули индивидуальность комплекса
              &laquo;Театральный Дом&raquo; и&nbsp;его сомасштабность окружающей
              застройке
            </span>
          }
        />
      </Sticker>
    </Spreader>
    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Grid
        fullWidth={3}
        blocks={[
          {
            width: 2,
            content: (
              <Scalable>
                <img src="images/media/grid21_2.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable style={{ marginBottom: '5%', marginLeft: '5%' }}>
                <img src="images/media/grid31_3.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable
                style={{
                  marginLeft: '5%',
                  width: '95%',
                  boxSizing: 'border-box',
                }}
              >
                <img src="images/media/grid41_2.jpg" width="100%" />
              </Scalable>
            ),
          },
        ]}
      />
      <Mention>
        На фото: Резиденция{' '}
        <a
          href="https://theater-house.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          target="_blank"
        >
          «Театральный Дом»
        </a>
      </Mention>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Во&nbsp;внешнем облике комплекса, в&nbsp;котором всего 129 апартаментов,
      воплощен принцип синтеза искусств, рассказывает старший вице-президент
      &laquo;Галс-Девелопмент&raquo; Леонид Капров. Декор фасадных решений
      находит продолжение во&nbsp;входных группах, при отделке которых
      использованы натуральные материалы; там повешены люстры из&nbsp;богемского
      стекла, установлены дубовые двери с&nbsp;витражным остеклением.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Чтобы полностью соответствовать духу места, где в&nbsp;XIX веке селились
      меценаты и&nbsp;покровители искусств, &laquo;Галс-Девелопмент&raquo;
      заключил договор с&nbsp;Государственным центральным Театральным музеем
      им.&nbsp;А. А. Бахрушина на&nbsp;приобретение 18 цифровых фотокопий
      театральных афиш XX&nbsp;века к&nbsp;постановкам произведений российской
      и&nbsp;зарубежной литературы, а&nbsp;также трех произведений
      живописи&nbsp;&mdash; &laquo;Зал старого дворцового театра
      в&nbsp;Вене&raquo; (Г.&nbsp;Климт, 1889&nbsp;г.),
      &laquo;В&nbsp;опере&raquo; (М. Кассат, 1879&nbsp;г.), &laquo;Спектакль
      в&nbsp;Московском Большом театре по&nbsp;случаю священного коронования
      императора Александра II&raquo; (М. Зичи, 1856 год). Репродукции украшают
      входные группы восьми секций комплекса.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Копии картин рубежа XIX&ndash;XX столетий украсили и&nbsp;другие
      общественные пространства. Всего в&nbsp;коллекции 72 произведения. Картины
      и&nbsp;афиши XIX&ndash;XX века, отдавая дань традиции, превращают
      общественные пространства дома в&nbsp;арт-галерею.
    </Spreader>
    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Scalable>
        <Banner
          text="За детальной информацией переходите на сайт  hals&#8209;development.ru"
          linkTitle="Перейти на сайт сейчас"
          link="https://hals-development.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          bannerBackground="images/banner-bg.png"
        />
      </Scalable>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Не&nbsp;менее трепетное отношение к&nbsp;архитектурному окружению
      и&nbsp;у&nbsp;проекта{' '}
      <a
        href="https://winehouse-hals.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        Wine House
      </a>{' '}
      на&nbsp;острове Балчуг.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Жилой квартал возведен в&nbsp;районе Замоскворечье по&nbsp;проекту
      мастерских SPEECH и&nbsp;ТПО &laquo;Резерв&raquo;. Комплекс клубных домов
      &laquo;рассказан&raquo; двумя архитектурными языками. Корпуса
      в&nbsp;исполнении ТПО &laquo;Резерв&raquo; решены лаконично. Фасады SPEECH
      более декоративны, в&nbsp;них используется изящный рельеф
      со&nbsp;стилизованным растительным орнаментом. &laquo;Разнообразие деталей
      и&nbsp;высокое качество их&nbsp;проработки и&nbsp;делают этот комплекс
      единым ансамблем, а&nbsp;сочетание в&nbsp;одном проекте двух совершенно
      разных архитектурных почерков придает ему по-настоящему уникальный
      и&nbsp;при этом легко узнаваемый облик&raquo;,&nbsp;&mdash; говорит
      управляющий партнер архитектурного бюро SPEECH Сергей Чобан.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Композиционной жемчужиной квартала является отреставрированное
      историческое здание XIX века, в&nbsp;котором расположены лофт-апартаменты.
      &laquo;В&nbsp;жилом комплексе Wine House центральным является
      взаимодействие архитектуры исторического корпуса, связанного стилистически
      с&nbsp;застройкой Замоскворечья, и&nbsp;новых жилых блоков.
      Мы&nbsp;внимательно подошли к&nbsp;соблюдению высотности, поддержке
      карнизных линий зданий, прилегающих к&nbsp;кварталу. Очень хорошо работает
      террасное решение корпусов с&nbsp;понижением к&nbsp;красной линии.
      Расположение объекта в&nbsp;исторической части города предопределило выбор
      натурального камня для отделки фасадов&raquo;,&nbsp;&mdash; рассказывает
      о&nbsp;проекте главный архитектор ТПО &laquo;Резерв&raquo; Владимир
      Плоткин. На&nbsp;верхних этажах новых особняков представлены жилые
      резиденции с&nbsp;открытыми террасами и&nbsp;каминами.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Недавно на&nbsp;территории открылся фонтан, завершивший проект
      благоустройства внутреннего двора. Двор вымощен палубной доской
      и&nbsp;серым гранитом, напоминающим морскую гладь. Декоративный пейзажный
      фонтан с&nbsp;шестью бьющими потоками воды и&nbsp;чашей из&nbsp;природного
      камня расположен в&nbsp;центре. Фонтан оснащен подводной RGB-подсветкой,
      раскрывающей красоту водных струй и&nbsp;перепадов в&nbsp;вечернее
      и&nbsp;ночное время и&nbsp;интегрирован в&nbsp;многоуровневую ландшафтную
      композицию с&nbsp;цветочными клумбами, деревянными скамейками
      и&nbsp;малыми архитектурными формами&nbsp;&mdash; пейзаж напоминает
      о&nbsp;ностальгической, старой, настоящей Москве.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Большая архитектурная ответственность и&nbsp;у&nbsp;проектов-доминант
      &laquo;Наследие&raquo; и{' '}
      <a
        href="https://dostoyanie-hals.ru?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        &laquo;Достояние&raquo;
      </a>
      &nbsp;&mdash; оба комплекса возвращают нас к&nbsp;образу настоящей
      &laquo;открыточной&raquo; Москвы. Первый строится в&nbsp;Преображенском
      районе по&nbsp;проекту мастерской ТПО &laquo;Резерв&raquo;
      и&nbsp;претендует на&nbsp;роль архитектурной вершины района. Выразительный
      комплекс с&nbsp;узнаваемыми элементами архитектуры Москвы 50-60-х гг.,
      не&nbsp;теряя связи с&nbsp;современностью, возвращает нам архитектурные
      ценности прошлого. Во&nbsp;внешней отделке использован натуральный камень
      и&nbsp;изящные орнаменты с&nbsp;традиционным для советской архитектуры
      середины прошлого столетия растительным мотивом. В&nbsp;здании
      предусмотрены декорированные технические балконы для размещения наружных
      блоков систем кондиционирования квартир&nbsp;&mdash; такое решение
      декорирования технических помещений разработали еще в&nbsp;30-40-е годы
      советские архитекторы-новаторы. Архитектурная концепция также включает
      уникальные для жилья бизнес-класса квартиры на&nbsp;первом этаже
      с&nbsp;собственным входом и&nbsp;небольшой открытой террасой,
      и&nbsp;квартиры, оборудованные дымоходами для установки каминов,
      на&nbsp;последних этажах.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Отличительной особенностью проекта являются современная концепция
      благоустройства территории &laquo;двор без машин&raquo; и&nbsp;авторское
      ландшафтное озеленение, гармонично дополняющее необходимую
      инфраструктуру&nbsp;&mdash; две детские площадки, детский сад.
    </Spreader>
    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Scalable style={{ marginBottom: '1.5%' }}>
        <img width="100%" src={'images/media/grid12_1.jpg'} />
      </Scalable>
      <Mention>
        На фото: ЖК{' '}
        <a
          href="https://theater-house.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          target="_blank"
        >
          «Достояние»
        </a>
      </Mention>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      &laquo;Достояние&raquo;&nbsp;&mdash; новая доминанта района Кунцево.
      Архитектурный проект жилого комплекса разработан мастерской
      &laquo;ГРАН&raquo; под руководством заслуженного архитектора России Павла
      Андреева. Фасадные решения выполнены в&nbsp;традиционной манере
      с&nbsp;использованием классического пропорционального трехчастного
      построения объемов, объединяющего в&nbsp;себе элементы позднего
      классицизма и&nbsp;ар-деко. Для внешнего облика комплекса характерны
      строгая геометрия и&nbsp;современный рисунок традиционных элементов,
      экспериментальные строительные материалы и&nbsp;изделия, работа над
      силуэтом и&nbsp;внедрение орнаментального декора. В&nbsp;отделке фасадов
      и&nbsp;интерьеров используются натуральные материалы&nbsp;&mdash; камень,
      дерево, металл в&nbsp;сочетании с&nbsp;элементами
      декоративно-художественного оформления, озеленения и&nbsp;архитектурного
      освещения: все современное и&nbsp;лучшее, но&nbsp;в&nbsp;то&nbsp;же время
      базируется на&nbsp;старой доброй классике, так любимой москвичами.
      По&nbsp;словам Леонида Капрова, выбор архитектурной концепции обусловлен
      местоположением комплекса в&nbsp;исторической части города, а&nbsp;также
      популярностью классических архитектурных форм у&nbsp;покупателей
      недвижимости высокого класса. Понятно, что интерес покупателей вызывает
      не&nbsp;только внешний вид, но&nbsp;и&nbsp;внутреннее наполнение, которое
      не&nbsp;менее впечатляюще. Авторами проекта разработана концепция
      общественных пространств, созданная в&nbsp;традициях советского
      монументального искусства середины XX&nbsp;века. Входные группы корпусов
      &laquo;Наука&raquo;, &laquo;Культура&raquo; и&nbsp;&laquo;Искусство&raquo;
      украшают шесть художественных панно из&nbsp;смальтовой мозаики
      с&nbsp;изображением ярких культурных символов и&nbsp;великих деятелей
      прошлого века. Мозаичные панно выполнены вручную.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Художественные изображения во&nbsp;входной группе башни
      &laquo;Наука&raquo; посвящены освоению космоса. В&nbsp;интерьере
      представлены мозаичные панно с&nbsp;изображением героя СССР,
      первооткрывателя космоса, летчика-космонавта Юрия Гагарина. Башню
      &laquo;Искусство&raquo; украшает панно с&nbsp;изображением монументальной
      скульптуры Веры Мухиной &laquo;Рабочий и&nbsp;Колхозница&raquo;, названной
      современниками &laquo;идеалом и&nbsp;символом советской эпохи&raquo;.
      Во&nbsp;входной группе башни &laquo;Культура&raquo; представлена мозаика,
      посвященная знаковым архитектурным символам нашей страны. Концепция
      интерьеров продолжена серией тематических фотографий и&nbsp;плакатов.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      На&nbsp;территории квартала создана авторская ландшафтная композиция.
      Центральным элементом проекта благоустройства является &laquo;зеленый
      лабиринт&raquo;&nbsp;&mdash; кустарники, посаженные в&nbsp;форме звезды,
      символа проекта &laquo;Достояние&raquo;. Кстати, такие дворы были
      популярны в&nbsp;&laquo;министерских&raquo; домах середины 50-х.
      Во&nbsp;внутреннем дворе располагается детская площадка с&nbsp;игровым
      комплексом, спортивная площадка с&nbsp;функциональными тренажерами,
      деревянные скамейки и&nbsp;декоративные клумбы.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Проекты{' '}
      <a
        href="https://iskra-park.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        &laquo;Искра-Парк&raquo;
      </a>{' '}
      и&nbsp;
      <a
        href="https://matchpointhouse.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        Match Point
      </a>{' '}
      продолжают визуальный ряд парадных проспектов&nbsp;&mdash; Ленинградского
      и&nbsp;Кутузовского, где всегда работали лучшие архитекторы, а&nbsp;вдоль
      &laquo;красной линии&raquo; москвоведы водят экскурсии, долго рассказывая
      о&nbsp;каждом доме, его авторах и&nbsp;именитых обитателях. Фасады
      &laquo;Искра-Парка&raquo; тоже совсем скоро войдут в&nbsp;экскурсионную
      программу&nbsp;&mdash; во&nbsp;всей красе квартал предстанет в&nbsp;начале
      2019 года. Для каждой из&nbsp;десяти секций здания &laquo;Студия Артемия
      Лебедева&raquo; разработала уникальный авторский рисунок-паттерн,
      отражающий достижения СССР в&nbsp;период 30-60-х годов XX&nbsp;века
      в&nbsp;таких отраслях, как авиастроение, космическая индустрия, нефтяная
      и&nbsp;атомная промышленность, машиностроение, энергетика, судостроение,
      транспорт, сельское хозяйство и&nbsp;строительство. Рисунок на&nbsp;фасаде
      каждой из&nbsp;секций посвящен отдельной отрасли. Оформление секции
      &#8470;&nbsp;2 иллюстрирует достижения нашей страны в&nbsp;атомной
      промышленности и&nbsp;посвящен открытию первой в&nbsp;мире атомной
      электростанции в&nbsp;г.&nbsp;Обнинск в&nbsp;1954 году.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      На&nbsp;внутренних и&nbsp;внешних фасадах будет размещено около 3 тыс.
      декоративных элементов-решеток, которые превращают комплекс
      в&nbsp;архитектурную достопримечательность, при этом не&nbsp;вырывая его
      из&nbsp;существующего контекста&nbsp;&mdash; так, решетками
      с&nbsp;растительным узором, созданным по&nbsp;проекту Владимира
      Фаворского, украшен известный &laquo;Ажурный Дом&raquo;, расположенный
      на&nbsp;этой&nbsp;же стороне проспекта, чуть ближе к&nbsp;центру.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Проект{' '}
      <a
        href="https://matchpointhouse.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
        target="_blank"
      >
        Match Point
      </a>
      , расположенный на&nbsp;Кутузовском проспекте, имеет совсем другой
      суперсовременный архитектурный облик, который обусловлен близостью
      &laquo;Москва-Сити&raquo;. Архитектурные решения комплекса разработаны
      мастерской &laquo;Группа АБВ&raquo;. Конструктивной изюминкой комплекса
      является спортивная волейбольная арена, фасады которой украсят стеклянные
      витражи. Архитектурные решения проекта предполагают использование
      композитных алюминиевых панелей, стеклянных витражей и&nbsp;натурального
      камня&nbsp;&mdash; юрского известняка. Во&nbsp;внешней отделке также будут
      применяться ламели&nbsp;&mdash; витражные конструкции с&nbsp;вертикальными
      солнцезащитными панелями. По&nbsp;окончании строительства волейбольная
      арена, рассчитанная на&nbsp;3500 зрителей, станет новой тренировочной
      базой для спортивного общества &laquo;Динамо&raquo;. Комплекс включает два
      тренировочных поля, зал специальной физической подготовки, банный
      комплекс, медицинский центр, массажные кабинеты, пресс-центр
      и&nbsp;конференц-зал, оборудованные системами синхронного перевода,
      а&nbsp;также зоны для спортивных комментаторов. Колористическое решение
      волейбольной арены будет выполнено в&nbsp;официальных цветах спортивного
      общества &laquo;Динамо&raquo;. Жить полной жизнью Match Point начнет
      в&nbsp;конце 2019 года, когда завершатся все строительные работы.
    </Spreader>
  </StickyContainer>
);

export default ArchitecturePage;

//<CallToAction />
